import React from 'react';
import { Star } from 'lucide-react';
import { useLanguage } from '../../../language/hooks/useLanguageHook';
import { testimonialsData, testimonialResultsStats } from '../../data/landingPageData'; // Import data

const TestimonialsSection = () => {
  const { t } = useLanguage();

  return (
    <div className="relative z-10 bg-white">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="text-center mb-16 scroll-fade-in">
          <h2 className="text-4xl font-bold mb-4">
            {t("public.landing.testimonials.title")}
          </h2>
          <p className="text-xl text-gray-600">
            {t("public.landing.testimonials.subtitle")}
          </p>
        </div>

        {/* Testimonial Cards */}
        {/* Consider adding a carousel library for better UX if many testimonials */}
        <div className="grid md:grid-cols-3 gap-8 mb-16 scroll-slide-in">
          {testimonialsData.map((testimonial) => (
            <div key={testimonial.key} className="bg-white rounded-xl p-8 shadow-lg border border-gray-100 hover:shadow-blue-100 transition-shadow duration-300 ease-in-out">
              <div className="flex items-center mb-6">
                <img
                  src={testimonial.image} // Use image path from data
                  alt={t(`public.landing.testimonials.items.${testimonial.key}.author`)} // Translate alt text
                  className="w-12 h-12 rounded-full mr-4 bg-gray-200" // Added bg for placeholder
                />
                <div>
                  <h3 className="font-semibold text-lg">
                    {t(`public.landing.testimonials.items.${testimonial.key}.author`)}
                  </h3>
                  <p className="text-gray-600">
                    {t(`public.landing.testimonials.items.${testimonial.key}.role`)}
                  </p>
                </div>
              </div>
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                ))}
              </div>
              <p className="text-gray-600 italic">
                {`"${t(`public.landing.testimonials.items.${testimonial.key}.text`)}"`}
              </p>
            </div>
          ))}
        </div>

        {/* Results Section */}
        <div className="bg-gray-100 rounded-3xl p-12 md:p-16 scroll-fade-in">
          <h3 className="text-3xl font-bold text-center mb-4 text-gray-900">
            {t("public.landing.testimonials.results.title")}
          </h3>
          <p className="text-xl text-gray-600 text-center mb-12">
            {t("public.landing.testimonials.results.subtitle")}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
            {testimonialResultsStats.map((stat) => (
              <div key={stat.labelKey} className="text-center">
                <div className="text-4xl font-bold text-blue-600 mb-2">
                  {/* Assuming value keys directly hold the value string e.g. "300%" */}
                  {/* If value key needs translation/lookup, adjust here */}
                  {t(stat.valueKey, stat.valueKey.split('.').pop())} {/* Provide fallback */}
                </div>
                <div className="text-gray-700">
                  {t(stat.labelKey)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsSection; 